import {getYear} from 'date-fns'

export default function Footer() {
	return (
		<footer className="absolute bottom-0 w-full flex items-center justify-center h-20 border-t border-gray-900 text-center text-gray-800 text-sm">
			© 2020 - {getYear(new Date())} Citrus Finance - All Rights Reserved
		</footer>
	)
}
